import RecoverStep from "../recover_step";
import {AJAX_DATA_TYPE_JSON} from "../../utils/recover_consts";
import {convertAutoStopValueToMinutes} from "../../../../modules/helpers/vo-helper";

const TEMPLATE = 'virtualization-failover';

export default class SetVirtualizationFailover extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        const baseUrl = data.type === 'recover-gen2' ? '/api/recover_flow/load_brc_failover_setup' : '/api/recover_flow/load_rb_failover_setup';
        $.ajax({
            type: "GET",
            url: `${baseUrl}/${data.clientId}/0/${data.deviceId ? ('/' + data.deviceId) : ''}`,
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json",
            success: function(response) {
                data.render = {
                    contentLoaded: true,
                    apps: response.data.apps,
                    d2cDeviceCount: response.data['d2c_count'],
                    vaultOnlyCount: response.data['vault_only_count'],
                    currentApplianceId: data.applianceId,
                    currentD2cDevice: data.deviceId && response.data['selected_d2c_device'],
                    currentVaultOnlyDevice: data.deviceId && response.data['selected_vault_only_device'],
                    clientName: response.data['client_name'],
                    gateway: response.data.gateway,
                    netmask: response.data.netmask,
                    isTest: data.recovery.virtualization.isTest
                };
                fr.render('setVirtualizationFailover');
            }
        }).fail(fr.defaultAJAXErrorHandler);
    }

    transitionCreate(data, el, fr) {
        const startVoButton = document.getElementById("start_vo_btn");
        const appIds = $("input[name=selected_services][id*=app_ids_]:checked").map(function () {
            return $(this).val();
        }).get();
        const d2cSelected = $("#d2c").prop('checked');
        const vaultOnlySelected = $("#vault_only").prop('checked');

        const selectedServices = $("input[name=selected_services]:checked").map(function () {
            return $(this).val(); // for form validation
        }).get();

        const voExists = checkVOExist(data.clientId, false);

        if (voExists) {
            const voDetailsUrl = '/client/details/' + data.clientId + '/1';
            tabs_goto(voDetailsUrl);
            return;
        }

        const failoverData = {
            client_id: data.clientId,
            app_ids: appIds,
            d2c_selected: d2cSelected,
            vault_only_selected: vaultOnlySelected,
            virtualization_type: data.recovery.virtualization.isTest ? 'test' : 'production',
            type: data.type,
            selected_services: selectedServices
        };
        if (data.recovery.virtualization.autoStopValue) {
            failoverData.stop_after_minutes = convertAutoStopValueToMinutes(data.recovery.virtualization.autoStopValue)
        }
        $(el).find('input[type=text]').each(function () {
            failoverData[$(this).attr('name')] = $(this).val();
        });
        if (startVoButton) {
            startVoButton.disabled = true;
        }

        $.ajax({
            url: '/cloud_ajax/create_failover',
            type: 'POST',
            data: failoverData,
            dataType: 'json',
            success: function (rv, status) {
                if (rv.is_error) {
                    nguxSettings.displayValidationErrors($(el), rv.errors);
                    if (startVoButton) {
                        startVoButton.disabled = false;
                    }
                } else {
                    data.recovery.failoverId = rv.failover_id;
                    data.render.hasError = false;
                    fr.goTo('createFailover');
                }
            }
        }).fail(function (xhr, status, error) {
            fr.defaultAJAXErrorHandler(xhr, status, error);
            if (startVoButton) {
                startVoButton.disabled = false;
            }
        });
    }
}
